/**
 * Date and time line printed on the badge: `Sep 18, 2026 · 4:00 PM`.
 * Rendered in the office's time zone rather than the device's, so a badge
 * printed from the web for another office shows the visitor's local time.
 */
export const formatBadgeDateTime = (
  date: Date,
  timeZone?: string | null
): string => {
  const options = { timeZone: timeZone || undefined };
  try {
    return formatWith(date, options);
  } catch {
    // An unknown IANA zone throws a RangeError; the device zone is the best we can do.
    return formatWith(date, {});
  }
};

const formatWith = (date: Date, options: { timeZone?: string }): string => {
  const day = date.toLocaleDateString("en-US", {
    ...options,
    month: "short",
    day: "numeric",
    year: "numeric"
  });
  const time = date.toLocaleTimeString("en-US", {
    ...options,
    hour: "numeric",
    minute: "2-digit",
    hour12: true
  });
  return `${day} · ${time}`;
};
